<script>
    import {getProductTypes, newProductType} from "../firestore";

    let productTypes = []

    let newProduct;

    function updateTypes(){
        productTypes = []
        getProductTypes().subscribe(product => productTypes = [...productTypes, product]);
    }

    updateTypes();

    function newType(){
        newProductType(newProduct);
        newProduct = "";
        updateTypes();
    }

    function removeType(id){
        firebase.firestore().collection("productTypes").doc(id).delete();
        updateTypes();
    }
</script>

<svelte:head><title>Axces2 - Product types</title></svelte:head>

<div class="container-fluid">
    <div class="row page-titles">
        <div class="col-md-5 col-8 align-self-center">
            <h3 class="text-themecolor">Product types</h3>
            <ol class="breadcrumb">

                <li class="breadcrumb-item">Admin</li>
                <li class="breadcrumb-item active">Product types</li>
            </ol>
        </div>
    </div>

    <section>
       <div class="card-group">
           <div class="card">
               <div class="card-body">
                   <div class="month-table">
                       <div class="table-responsive mt-3">
                           <table class="table stylish-table mb-0">
                               <thead>
                               <tr>
                                   <th>Product name</th>
                               </tr>
                               </thead>
                               <tbody>
                               {#each productTypes as product, i(product.id)}
                                   <tr>
                                       <td>
                                           <div>{product.name}</div>
                                       </td>
                                       <td class="td-actions text-right">
                                           <button on:click={() => removeType(product.id)} rel="tooltip" class="btn btn-danger btn-round">
                                               <i class="mdi mdi-delete"></i>
                                           </button>
                                       </td>
                                   </tr>
                               {/each}
                               </tbody>
                           </table>
                           <input class="card-highlight" bind:value={newProduct}/>
                           <button on:click={newType} class="btn btn-primary">New</button>
                       </div>
                   </div>
               </div>
           </div>
       </div>
    </section>
</div>
